import checkout from "layouts/users/new-user/schemas/form";

const {
  formField: { firstName, lastName, number, email, type, password, repeatPassword },
} = checkout;

const initialValues = {
  [firstName.name]: "",
  [lastName.name]: "",
  [number.name]: "",
  [type.name]: "Customer",
  [email.name]: "",
  [password.name]: "",
  [repeatPassword.name]: "",
};

export default initialValues;
